module.exports = "images/homepage.24f09730.png";